/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const CREATE_TRANSACTION_DOCUMENT_FOR_USER = gql`
  mutation CreateTransactionDocumentForUser(
    $request: CreateTransactionDocumentRequest!
  ) {
    CreateTransactionDocumentForUser(request: $request) {
      id
    }
  }
`;
